/**
 * CHAT-DUET (his pick, 2026-10-28): the chat's message bubbles, one set of classes for every chat in the app (the
 * Assistant in both modes, the Morning greeting and its lines, the Thread tab). His own messages are a soft tint of the
 * Apex red (`primary-100`), the way Duet tints its own colour; the assistant's and anyone else's are light grey.
 * Text: 17 px on a phone, 15 px from `sm` (the rail is a 342-380 px column beside 14 px pages).
 */
export const BUBBLE =
  'rounded-[20px] px-4 py-3 text-[17px] leading-[23px] tracking-[-0.011em] text-chat-ink sm:text-[15px] sm:leading-[21px]';
export const ASSISTANT_BUBBLE = `${BUBBLE} bg-chat-bubble`;
export const USER_BUBBLE = `${BUBBLE} bg-primary-100`;
/** A short line from the assistant ("These need you:") - a smaller grey bubble, as wide as its words, on a line of its own. */
export const LINE_BUBBLE =
  'table rounded-[20px] bg-chat-bubble px-3.5 py-2 text-[17px] leading-[23px] tracking-[-0.011em] text-chat-ink sm:text-[15px] sm:leading-[21px]';
